import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { useMultiStyleConfig as u, Popover as v, Box as b, PopoverTrigger as h, PopoverContent as f, PopoverHeader as n, PopoverBody as g } from "@chakra-ui/react";
import { MobileMenuHeader as M } from "./MobileMenuHeader.mjs";
import "../../forms/Button/Button.mjs";
import { IconButton as x } from "../../forms/Button/IconButton.mjs";
import "../../forms/Button/ButtonGroup.mjs";
import { GlobalNavv2 as C } from "../../GlobalNav/GlobalNavv2.mjs";
import { XmarkIcon as P, BarsIcon as y } from "../../icons/componentIcons.mjs";
import { useGlobalHeaderv2DevContext as B, useGlobalHeaderv2PrivateContext as G } from "./useGlobalHeaderv2Context.mjs";
import { Tooltip as H } from "../../overlay/Tooltip/Tooltip.mjs";
import { RemoveScroll as R } from "react-remove-scroll";
const X = ({
  heightOffset: a,
  isSignedIn: i,
  mobileMenuBody: s,
  mobileMenuHeader: l,
  onClick: d,
  userName: m
}) => {
  const t = u("GlobalHeaderv2"), { isMobileMenuOpen: o, onMobileMenuClose: p } = B(), { isGlobalNavRegistered: c } = G();
  return /* @__PURE__ */ r(v, { gutter: 14, isOpen: o, onClose: p, variant: "fullWidth", children: [
    /* @__PURE__ */ e(H, { label: "Menu", children: /* @__PURE__ */ e(b, { display: "inline-block", children: /* @__PURE__ */ e(h, { children: /* @__PURE__ */ e(
      x,
      {
        "aria-label": "Menu",
        variant: "ghost",
        size: "md",
        borderRadius: "full",
        icon: o ? /* @__PURE__ */ e(P, { variant: "light", size: "lg" }) : /* @__PURE__ */ e(y, { variant: "light", size: "lg" }),
        onClick: d
      }
    ) }) }) }),
    /* @__PURE__ */ e(R, { className: "scroll", forwardProps: !0, enabled: !!o, children: /* @__PURE__ */ r(f, { sx: t.mobileMenuContent, height: `calc(100vh - ${a}px)`, children: [
      l ? /* @__PURE__ */ e(n, { padding: 0, children: l }) : i && /* @__PURE__ */ e(n, { padding: 0, children: /* @__PURE__ */ e(M, { userName: m }) }),
      /* @__PURE__ */ r(g, { sx: t.mobileMenuBody, children: [
        s,
        i && !c && /* @__PURE__ */ e(
          C,
          {
            variant: "mobile",
            marginTop: 2,
            disableRegistration: !0
          }
        )
      ] })
    ] }) })
  ] });
};
export {
  X as MobileMenu
};
